import { Route, Routes } from "react-router-dom"
import { Settings } from "../../pages/Settings"

const SettingsFlow = () => (
  <Routes>
    <Route element={<Settings />} index />
  </Routes>
)

export default SettingsFlow
